
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import StepList from "@/components/scope/step-list.vue";
import dayjs from "dayjs";
import ConfirmPaymentItem from "../components/confirm-payment.vue";
import RegisterInvoice from "../components/register-invoice.vue";
import t from "@common/src/i18n/t";
import { addCurrencyUnit, partsPropComb } from "@common/src/utils/tools";

const service = namespace("service");
const setting = namespace("setting");
const purchase = namespace("purchase");
const app = namespace("app");
const staff = namespace("staff");
const inventory = namespace("inventory");

@Component({
  components: {
    StepList,
    ConfirmPaymentItem,
    RegisterInvoice
  }
})
export default class PurchaseRefundView extends Vue {
  @purchase.Action purchaseComplete;
  @purchase.Action getReturnPurchaseModel;
  @purchase.Action cancelReturnPurchase;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Action receiveReturnPurchase;
  @purchase.Action outBoundReturnPurchase;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  @inventory.Action queryInventoryAndNotice;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  @staff.Action getStaffList;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  partsPropComb = partsPropComb;
  get breadData() {
    return [
      { name: t("v210901.purchase-return"), path: "/purchase/refund-index" },
      { name: t("v210901.purchase-return-order-details") }
    ];
  }
  get additionalList() {
    if (!this.detailData.additionalFees) {
      return [];
    }
    return [
      {
        additionalFees: Number(this.detailData.additionalFees) ? this.detailData.additionalFees : "-",
        additionalFeesRemark: this.detailData.additionalFeesRemark
      }
    ];
  }
  created() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
    this.init();
  }
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.cancelReturnPurchase({
        returnPurchaseNo: this.orderId
      }).then(() => {
        this.$message.success(t("finance.cancel-success"));
        this.init();
      });
    }
  }
  get orderId() {
    return this.$route.params.id;
  }
  emptyToLine = emptyToLine;
  detailData: any = {};
  showReceive: any = false;
  payWayList: any = [];
  receiveFormData: any = {
    paidAmount: "",
    paidMethod: "",
    paidMethodDesc: "",
    returnPurchaseNo: "",
    remark: ""
  };
  receiveFormDataRules: any = {
    paidMethod: [{ required: true, message: t("v210901.please-select-the-collection-method"), trigger: "change" }]
  };
  handleReceive() {
    this.showReceive = true;
  }
  handleConfirmReceive() {
    if (!this.receiveFormData.paidMethod) {
      return this.$message.error(t("v210901.please-select-the-collection-method"));
    }
    this.receiveFormData.paidMethodDesc = this.payWayList.find(
      v => v.payMethodCode === this.receiveFormData.paidMethod
    ).payMethodName;
    this.receiveFormData.returnPurchaseNo = this.orderId;
    this.receiveReturnPurchase(this.receiveFormData).then(() => {
      this.showReceive = false;
      this.$message.success(t("service.payment-success"));
      this.init();
    });
  }
  showOutbound: any = false;
  handleOutbound() {
    this.showOutbound = true;
  }
  handleConfirmOutbound() {
    this.outBoundReturnPurchase({ returnPurchaseNo: this.orderId }).then(data => {
      this.showOutbound = false;
      this.$message.success(t("warehouse.outbound-success"));
      this.init();
      if (data.data.validateInventoryAlert === "1") {
        const partsCodeList = this.detailData.returnPurchaseDetailList.map(item => item.partsCode);
        if (partsCodeList && partsCodeList.length > 0) {
          this.queryInventoryAndNotice(partsCodeList);
        }
      }
    });
  }
  advisorList: any = [];
  async init() {
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    this.getReturnPurchaseModel({
      returnPurchaseNo: this.orderId
    }).then(data => {
      this.detailData = data?.data || {};
      this.receiveFormData.paidAmount = this.detailData?.returnPurchaseAmount;
      this.detailData.returnUserName = this.advisorList.find(
        v => v.userCode === this.detailData.returnUserCode
      ).staffName;
    });
  }
}
